import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardPage from './DashboardPage';

const DashboardPageWrapper: React.FC = () => {
  const navigate = useNavigate();
  
  return <DashboardPage navigate={navigate} />;
};

export default DashboardPageWrapper;
